import { FC } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import aboutimage from "../images/about-photo.jpeg";

const AboutSection: FC = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <div ref={ref} className="flex flex-col md:flex-row items-center p-8 overflow-hidden" style={{ backgroundColor: "#D9D9D9" }}>
      {/* Image Section */}
      <motion.div
        initial={{ x: -50, opacity: 0 }}  // Daha küçük değer
        animate={inView ? { x: 0, opacity: 1 } : {}}
        transition={{ duration: 1 }}
        className="relative md:w-1/2 w-full flex justify-center md:justify-end pr-4"
      >
        <img
          src={aboutimage}
          alt="Customer Service Experience"
          className="rounded-2xl shadow-lg"
          style={{
            width: "70%",
            height: "auto",
          }}
        />
      </motion.div>

      {/* Text Section */}
      <motion.div
        initial={{ x: 50, opacity: 0 }}  // Daha küçük değer
        animate={inView ? { x: 0, opacity: 1 } : {}}
        transition={{ duration: 1 }}
        className="md:w-1/2 w-full p-6"
      >
        <h2 className="text-[#092049] text-sm uppercase font-bold mb-2">
          Biz Kimiz?
        </h2>
        <h1 className="text-3xl font-extrabold mb-4">
          Mutlu Müşteri Politikası!
        </h1>
        <p className="text-gray-700 leading-relaxed mb-4">
        Kocabay Tur olarak, personel taşımacılığı sektöründe güven, konfor ve müşteri memnuniyetini en üst seviyeye çıkarmayı hedefliyoruz. Modern ve bakımlı araç filomuz, deneyimli sürücülerimiz ve yenilikçi hizmet anlayışımız ile sektörde öncü olmayı amaçlıyoruz. Teknolojik gelişmeleri yakından takip ederek, sürdürülebilir ve çevre dostu taşımacılık çözümleri sunarak her yolculuğu daha güvenli ve keyifli hale getirmeyi hedefliyoruz.
        </p>
        <p className="text-gray-700 leading-relaxed mb-6">
        Kocabay Tur, çalışanların iş yerine güvenli ve konforlu bir şekilde ulaşmasını sağlamak için yüksek standartlarda personel taşımacılığı hizmeti sunmaktadır. Güvenli sürüş ilkelerine bağlı, düzenli bakımdan geçmiş modern araçlarımız ve profesyonel sürücü kadromuz ile müşterilerimizin beklentilerini en iyi şekilde karşılıyoruz. Hizmet kalitemizi sürekli geliştirerek, iş dünyasına verimli ve konforlu ulaşım çözümleri sunmaya devam ediyoruz.
        </p>
        <motion.a
          href="/hakkimizda"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="bg-[#092049] text-white px-6 py-2 rounded-2xl shadow hover:bg-cyan-600 transition inline-block"
        >
          Hakkımızda
        </motion.a>
      </motion.div>
    </div>
  );
};

export default AboutSection;
